import React, { ComponentType } from 'react';
import { FloatingComponentDataModel, FloatingComponentProps, FloatingComponentTypename } from '../types';



export const FloatingComponentsMap: {
    [component in FloatingComponentTypename]: React.LazyExoticComponent<any>;
} = {
    'FloatingItemsSingleIconLinkItem': React.lazy(() => import(/* webpackMode: "lazy" */ './single.icon.link.item')),
    'FloatingItemsSingleImageTextItem': React.lazy(() => import(/* webpackMode: "lazy" */ './single.image.text.item')),
    'FloatingItemsGroupedImageTextItem': React.lazy(() => import(/* webpackMode: "lazy" */ './grouped.image.text.item')),
    'FloatingItemsSingleImageItem': React.lazy(() => import(/* webpackMode: "lazy" */ './single.image.item')),
    'FloatingItemsSingleIconTextItem': React.lazy(() => import(/* webpackMode: "lazy" */ './single.icon.text.item')),
    'FloatingItemsGroupedIconTextItem': React.lazy(() => import(/* webpackMode: "lazy" */ './grouped.icon.text.item')),

};